
<template>
  <div>
      红冲办理
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/trading/invoice/redDashedTransact.vue